import React from 'react';
import { useTranslation } from 'react-i18next';
import './PrivacyPage.css';

const PrivacyPage: React.FC = () => {
  const { t } = useTranslation('legal');

  return (
    <div className="privacy-page">
      <div className="privacy-header">
        <h1>{t('privacy.title')}</h1>
        <p>{t('privacy.subtitle')}</p>

        <div className="wave-divider">
          <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
            <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className="shape-fill"></path>
          </svg>
        </div>
      </div>

      <section>
        <div className="privacy-content bg-white p-5 rounded shadow">
          <div className="privacy-intro">
            <p>{t('privacy.intro')}</p>
          </div>

          <h2>{t('privacy.general_title')}</h2>
          <ul>
            <li>{t('privacy.general_1')}</li>
            <li>{t('privacy.general_2')}</li>
            <li>{t('privacy.general_3')}</li>
            <li>{t('privacy.general_4')}</li>
          </ul>

          <h2>{t('privacy.data_collected_title')}</h2>
          <p>{t('privacy.data_collected_intro')}</p>
          <ul>
            <li>{t('privacy.data_collected_1')}</li>
            <li>{t('privacy.data_collected_2')}</li>
            <li>{t('privacy.data_collected_3')}</li>
            <li>{t('privacy.data_collected_4')}</li>
          </ul>

          <h2>{t('privacy.data_purpose_title')}</h2>
          <ul>
            <li>{t('privacy.data_purpose_1')}</li>
            <li>{t('privacy.data_purpose_2')}</li>
            <li>{t('privacy.data_purpose_3')}</li>
          </ul>

          <h2>{t('privacy.data_security_title')}</h2>
          <ul>
            <li>{t('privacy.data_security_1')}</li>
            <li>{t('privacy.data_security_2')}</li>
            <li>{t('privacy.data_security_3')}</li>
            <li>{t('privacy.data_security_4')}</li>
          </ul>

          <h2>{t('privacy.data_access_title')}</h2>
          <ul>
            <li>{t('privacy.data_access_1')}</li>
            <li>{t('privacy.data_access_2')}</li>
          </ul>

          <h2>{t('privacy.complaints_title')}</h2>
          <p>{t('privacy.complaints_1')}</p>
          <p>{t('privacy.complaints_2')}</p>

          <div className="privacy-footer">
            <p>{t('privacy.last_updated')}</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPage;
